var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12 text-bold bold mb-3" }, [
                _c("i", { staticClass: "fas fa-ticket-alt color-orange" }),
                _vm._v(" Reclamación ")
              ]),
              _c(
                "div",
                { staticClass: "col-md-3" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-date-picker", {
                                attrs: {
                                  "class-container": "w-100",
                                  "custom-error-msg":
                                    "Favor seleccione la fecha de reclamación.",
                                  error: errors[0],
                                  label: "Fecha:",
                                  "max-date": new Date(),
                                  "min-date": _vm.beforeBankRequestDate,
                                  placeholder: "DD/MM/YYYY"
                                },
                                model: {
                                  value: _vm.model.claimDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "claimDate", $$v)
                                  },
                                  expression: "model.claimDate"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-3" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("div", { staticClass: "data-name" }, [
                                _vm._v("Tipo de Reclamación")
                              ]),
                              _c("custom-radio-group", {
                                staticClass: "row mt-3",
                                attrs: {
                                  "custom-error-msg":
                                    "Favor seleccione PIN o Tarjeta.",
                                  error: errors[0],
                                  "field-key": "value",
                                  "is-inline": true,
                                  name: "claimTypes",
                                  options: _vm.radioButtonsOptions
                                },
                                model: {
                                  value: _vm.claimTypeSelected,
                                  callback: function($$v) {
                                    _vm.claimTypeSelected = $$v
                                  },
                                  expression: "claimTypeSelected"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-3" },
                [
                  _c("custom-input", {
                    attrs: { label: "Número de tarjeta:", type: "number" },
                    model: {
                      value: _vm.model.claimCardNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "claimCardNumber", $$v)
                      },
                      expression: "model.claimCardNumber"
                    }
                  })
                ],
                1
              ),
              _vm.showReasons
                ? _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: `${
                            _vm.claimTypeSelected == false ? "required" : ""
                          }`
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      clearable: false,
                                      "custom-error-msg":
                                        "Favor seleccionar razón.",
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Razón:",
                                      options: _vm.claimReasons,
                                      placeholder: "Seleccione"
                                    },
                                    model: {
                                      value: _vm.claimReasonSelected,
                                      callback: function($$v) {
                                        _vm.claimReasonSelected = $$v
                                      },
                                      expression: "claimReasonSelected"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "col-md-12 mt-2" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Nombre de quien reclama es requerido.",
                                      error: errors[0],
                                      label: "Nombre de quien reclama:"
                                    },
                                    model: {
                                      value: _vm.model.claimName,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "claimName", $$v)
                                      },
                                      expression: "model.claimName"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      clearable: false,
                                      "custom-error-msg":
                                        "Favor seleccionar parentezco.",
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Parentezco:",
                                      options: _vm.claimRelationships,
                                      placeholder: "Seleccione"
                                    },
                                    model: {
                                      value: _vm.model.claimRelationship,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "claimRelationship",
                                          $$v
                                        )
                                      },
                                      expression: "model.claimRelationship"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Teléfono es requerido.",
                                      error: errors[0],
                                      label: "Teléfono:",
                                      "mask-type": "Phone",
                                      placeholder: "(___) ___-____"
                                    },
                                    model: {
                                      value: _vm.model.claimPhone,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "claimPhone", $$v)
                                      },
                                      expression: "model.claimPhone"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c(
                "div",
                { staticClass: "col-md-12 mt-2" },
                [
                  _c("custom-text-area", {
                    attrs: {
                      label: "Comentario:",
                      maxlength: 500,
                      rows: 4,
                      "show-char-count": ""
                    },
                    model: {
                      value: _vm.model.claimComment,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "claimComment", $$v)
                      },
                      expression: "model.claimComment"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-12 text-right mt-3 pt-1" },
                [
                  _c("action-button", {
                    attrs: {
                      i: "fas fa-times-circle",
                      text: "Cancelar",
                      variant: "outline-danger mr-3"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("on-cancel")
                      }
                    }
                  }),
                  _c("action-button", {
                    attrs: {
                      i: "fas fa-save",
                      text: "Guardar",
                      variant: "success"
                    },
                    on: {
                      click: function($event) {
                        return handleSubmit(_vm.submit)
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }